import type { UseIssuesInput } from '@atlassian/jira-business-common/src/common/types/query-input.tsx';
import { useProject } from '@atlassian/jira-business-entity-project-hook/src/index.tsx';
import { useFilteredViewContextInput } from '@atlassian/jira-business-filters/src/controllers/default-query-input/index.tsx';
import { getGroupQuery } from '../../services/get-item-groups/utils.tsx';
import { useHierarchyLevel } from '../../services/hierarchy-level/index.tsx';
import { useIssueFields } from '../get-issue-fields/index.tsx';
import { useGroupBy } from '../group-by/index.tsx';
import { useHierarchyConfig } from '../hierarchy/hierarchy-config/index.tsx';
import { useHierarchyStore } from '../hierarchy/hierarchy-store/index.tsx';

export const useIssuesInput = (options?: {
	groupIssueId?: string | null;
	parentIssueId?: string | null;
}): UseIssuesInput => {
	const { groupIssueId, parentIssueId } = options || {};
	const [{ hierarchyLevel }] = useHierarchyLevel();
	const [{ hierarchyData }] = useHierarchyStore();
	const { jqlContext, quickFiltersJql, isHidingDoneItems } = useFilteredViewContextInput({
		view: 'list',
	});
	const { hierarchyParent } = useHierarchyConfig();
	const { getQueryFieldIds, isParentFieldVisible, isDevSummaryFieldVisible } = useIssueFields();
	const groups = hierarchyData.data;
	const [groupByFieldId] = useGroupBy();

	const projectData = useProject();
	const projectKey = projectData.key;

	let input: UseIssuesInput = {
		jqlContext,
		quickFiltersJql,
		projectIdOrKey: projectKey,
		fieldIds: getQueryFieldIds(),
		isHidingDoneItems,
		isParentFieldVisible: isParentFieldVisible(),
		isDevSummaryFieldVisible: isDevSummaryFieldVisible(),
	};
	if (groupIssueId != null) {
		input = {
			...input,
			hierarchyParent,
			groupQuery: getGroupQuery({
				groupIssueId,
				groupByFieldId,
				groups,
			}),
		};
	} else if (parentIssueId != null && hierarchyParent != null) {
		input = {
			...input,
			hierarchyParent: undefined,
			parentIssue: {
				hierarchyType: hierarchyParent,
				issueId: parentIssueId,
			},
		};
	} else {
		input.hierarchyLevel = hierarchyLevel;
		input.hierarchyParent = hierarchyParent;
	}
	return input;
};
